<template>
  <card>
    <h4 slot="header" class="card-title">Kullanıcı Güncelleme</h4>
    <a-form-model
      ref="ruleForm"
      :model="form"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
    >
      <a-form-model-item ref="first_name" label="İsim" prop="first_name">
        <a-input
          placeholder="İsim"
          v-model="form.first_name"
          @blur="() => { $refs.first_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="last_name" label="Soyisim" prop="last_name">
        <a-input
          placeholder="Soyisim"
          v-model="form.last_name"
          @blur="() => { $refs.last_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item label="Yetki Tipi" prop="roleType">
        <a-select
          show-search
          allowClear
          placeholder="Yetki tipi seçiniz"
          v-model="selectedRoleType"
          option-filter-prop="children"
          @change="onRoleTypeChange"
        >
          <a-select-option
            v-for="st in sortedSegmentTypes"
            :value="'segment_' + st.id"
            :key="'st_' + st.id"
          >
            {{ st.name + ' Yöneticisi' }}
          </a-select-option>
          <a-select-option v-if="isCurrentUserOrgAdmin" value="organizationAdmin">
            Organizasyon Yöneticisi
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        v-if="selectedSegmentTypeId"
        :label="selectedSegmentTypeName + ' Seçimi'"
        prop="managed_segment_id"
      >
        <a-select
          show-search
          allowClear
          :placeholder="selectedSegmentTypeName + ' seçiniz'"
          v-model="form.managed_segment_id"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="seg in segmentsForSelectedType"
            :value="seg.id"
            :key="seg.id"
          >
            {{ seg.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        label="Kumbara Atama"
        prop="moneybox_assignment"
        v-if="moneyboxes.moneyboxes && moneyboxes.count"
      >
        <a-select
          :value="selected_moneyboxes"
          show-search
          label-in-value
          option-filter-prop="children"
          mode="multiple"
          style="width: 100%"
          placeholder="Kumbara seçiniz"
          :filter-option="filterOption"
          @change="handleMoneyboxChange"
        >
          <a-select-option v-for="d in moneyboxList" :value="d.value" :key="d.value">
            {{ d.text }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Güncelle
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>

<script>
import { mapState } from 'vuex'
import Card from 'src/components/Cards/Card.vue'

function decodeJWT(token) {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (_) {
    return null
  }
}

export default {
  components: { Card },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    const self = this
    self.$store.dispatch('Moneybox/requestMoneyboxList')
    self.$store.dispatch('Segments/requestSegmentIndex').then((a) => {
      self.$store.dispatch('Segments/requestSegmentTypeIndex').then((b) => {
        self.segments = a.segments
        self.segmentTypes = b.segmentTypes
        self.initFromUser()
      })
    })
  },

  computed: {
    ...mapState({
      moneyboxes: (state) => state.Moneybox.moneyboxes,
    }),

    moneyboxList() {
      if (!this.moneyboxes.moneyboxes) return []
      return this.moneyboxes.moneyboxes.map((item) => ({
        text: item.name,
        value: item.id,
      }))
    },

    sortedSegmentTypes() {
      return this.segmentTypes.slice().sort((a, b) => a.rank - b.rank)
    },

    selectedSegmentTypeId() {
      if (!this.selectedRoleType || !this.selectedRoleType.startsWith('segment_')) return null
      return parseInt(this.selectedRoleType.replace('segment_', ''), 10)
    },

    selectedSegmentTypeName() {
      if (!this.selectedSegmentTypeId) return ''
      const st = this.segmentTypes.find((t) => t.id === this.selectedSegmentTypeId)
      return st ? st.name : ''
    },

    segmentsForSelectedType() {
      if (!this.selectedSegmentTypeId) return []
      return this.segments.filter((s) => s.segment_type_id === this.selectedSegmentTypeId)
    },

    isCurrentUserOrgAdmin() {
      const token = localStorage.getItem('access_token')
      if (!token) return false
      const claims = decodeJWT(token)
      return claims && Array.isArray(claims.roles) && claims.roles.includes('organizationAdmin')
    },
  },

  data() {
    return {
      segments: [],
      segmentTypes: [],
      selectedRoleType: undefined,
      selected_moneyboxes: [],
      loading: false,
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      form: {
        first_name: '',
        last_name: '',
        managed_segment_id: undefined,
      },
      rules: {
        first_name: [
          { required: true, message: 'İsim alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 50, message: 'İsim alanı 2-50 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        last_name: [
          { required: true, message: 'Soyisim alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 50, message: 'Soyisim alanı 2-50 karakter arasında olmalıdır', trigger: 'blur' },
        ],
      },
    }
  },

  methods: {
    initFromUser() {
      const self = this
      self.form.first_name = self.user.name || ''
      self.form.last_name = self.user.last_name || ''
      self.form.managed_segment_id = self.user.managed_segment_id || undefined

      if (self.user.roles && self.user.roles.includes('organizationAdmin')) {
        self.selectedRoleType = 'organizationAdmin'
      } else if (self.user.managed_segment_id) {
        const seg = self.segments.find((s) => s.id === self.user.managed_segment_id)
        if (seg) self.selectedRoleType = 'segment_' + seg.segment_type_id
      }

      if (self.user.moneybox_assignments && self.moneyboxes.moneyboxes) {
        self.selected_moneyboxes = self.user.moneybox_assignments.reduce((acc, item) => {
          const mb = self.moneyboxes.moneyboxes.find((x) => x.id === item.moneybox_id)
          if (mb) acc.push({ key: mb.id, label: mb.name })
          return acc
        }, [])
      }
    },

    onRoleTypeChange() {
      this.form.managed_segment_id = undefined
    },

    handleMoneyboxChange(value) {
      this.selected_moneyboxes = value
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },

    onSubmit() {
      const self = this
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        let roles = ''
        if (self.selectedRoleType === 'organizationAdmin') {
          roles = 'organizationAdmin'
        } else if (self.selectedRoleType) {
          roles = 'segmentAdmin'
        }

        const payload = {
          id: self.user.id,
          first_name: self.form.first_name,
          last_name: self.form.last_name,
          roles,
          managed_segment_id: roles === 'segmentAdmin' ? self.form.managed_segment_id : 0,
        }

        self.loading = true
        self.$store.dispatch('Users/requestUserUpdate', payload).then(() => {
          self.$notification.success({
            message: 'Kullanıcı Güncelleme',
            description: 'Kullanıcı başarılı bir şekilde güncellendi.',
          })

          const oldAssignments = self.user.moneybox_assignments || []
          const deleted = oldAssignments
            .filter((item) => !self.selected_moneyboxes.find((x) => x.key === item.moneybox_id))
            .map((item) => ({ key: item.id }))

          const added = self.selected_moneyboxes
            .filter((item) => !oldAssignments.find((x) => x.moneybox_id === item.key))

          if (added.length) {
            self.$store.dispatch('Users/requestUserMoneyboxAssignmentCreate', {
              user_id: self.user.id,
              selected_moneyboxes: added,
            })
          }
          if (deleted.length) {
            self.$store.dispatch('Users/requestUserMoneyboxAssignmentDelete', {
              user_id: self.user.id,
              deleted_moneyboxes: deleted,
            })
          }

          self.$router.push('/admin/users/')
        }).catch(() => {
          self.$notification.error({
            message: 'Kullanıcı Güncelleme',
            description: 'Kullanıcı güncellenirken bir hata oluştu.',
          })
        }).finally(() => {
          self.loading = false
        })
      })
    },

    resetForm() {
      this.$refs.ruleForm.resetFields()
      this.initFromUser()
    },
  },
}
</script>
